import React, { useEffect, useRef, ReactNode } from 'react';
import { useStore, observer } from 'base/store';
import { initCountdown, addCountdown, ICountdownConfig } from 'base/utils/countdown';
import Iconfont from '@base/lib/Iconfont';

export type { ICountdownConfig, RenderParamType } from 'base/utils/countdown';

type CountdownProps = ICountdownConfig & {
    className?: string;
    style?: React.CSSProperties;
    label?: ReactNode;
    arrow?: boolean | ReactNode;
};

export const Countdown: React.FC<CountdownProps> = observer(props => {
    const { userStore: { state: { currentTime } } } = useStore();
    const ref = useRef<HTMLDivElement>(null);
    const { className, style, label, arrow = false, ...itemConfig } = props;
    const { endTime } = itemConfig
    const isActive = endTime > 0 && currentTime > 0;

    useEffect(() => {
        if (isActive) {
            initCountdown(currentTime, {
                dayText: ['DAY', 'DAYS'],
                hourText: ['HOUR', 'HOURS'],
                minuteText: ['MINUTE', 'MINUTES'],
                secondText: ['SECOND', 'SECONDS'],
            });

            if (ref.current) {
                addCountdown(ref.current, {
                    ...itemConfig,
                    // endTime: currentTime + 3,
                    endContainer: label ? ref.current.parentElement as HTMLDivElement : void 0
                });
            }
        }
    }, [isActive]);

    if (!isActive) {
        return null;
    }
    if (label) {
        return (
            <div className={className} style={style}>
                {props.label}
                <div ref={ref}/>
                {arrow !== false && (typeof arrow !== 'boolean' ? arrow : <Iconfont className="icon-arrow-right"/>)}
            </div>
        );
    }
    return <div ref={ref} className={className} style={style}/>


});

export default Countdown;